import * as types from '../constants'

const defaultState = {
  library_control_reviews: [],
  action_type: "",
  exception: ""
}

export default (state = defaultState, action) => {

  var newState = {...state, action_type: action.type}

  switch (action.type){
    case types.GET_LIBRARY_CONTROL_REVIEWS.request:
    case types.LIBRARY_CONTROL_REVIEWS_MARK_AS_REVIEWED.request:
    case types.LIBRARY_CONTROL_REVIEWS_MARK_AS_REVIEWED.success:
      return newState;
    case types.GET_LIBRARY_CONTROL_REVIEWS.success:
      newState.library_control_reviews = action.data;
      return newState;
    case types.GET_LIBRARY_CONTROL_REVIEWS.failure:
    case types.LIBRARY_CONTROL_REVIEWS_MARK_AS_REVIEWED.failure:
      newState.exception = action.exception;
      return newState;
    default:  return state;
  }

}



// WEBPACK FOOTER //
// ./src/reducers/library_control_review.js